import { h, FunctionComponent } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { TextInput } from 'up-ops-web-shared-components';
import { trackFormBlur } from '~src/utils/tracking';
import { InputProps } from '../types/forms';

/**
  Usage: A <input> with css class, label
*/
const SimpleInput: FunctionComponent<InputProps> = props => {
  const {
    id,
    value,
    onChangeHandler,
    type = '',
    isDisabled = false,
    isRequired = false,
    isReadOnly = false,
    className = '',
    placeholder = '',
    centered = false,
    maxLength = 100,
  } = props;

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onBlurHandler = () => {
    dispatch(trackFormBlur(id));
    setIsFocused(false);
  };

  const onFocusHandler = () => {
    setIsFocused(true);
  };

  return (
    <TextInput
      innerRef={inputRef}
      id={id}
      ariaLabel='text input'
      type={type || 'text'}
      name={id}
      maxLength={maxLength}
      centered={centered}
      value={value}
      className={isFocused ? `${className} focused` : className}
      disabled={isDisabled}
      required={isRequired}
      readOnly={isReadOnly}
      placeholder={placeholder}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      onFocus={onFocusHandler}
      style={{}}
      aria-live='off'
    />
  );
};

export default SimpleInput;
